var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcKeywordNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.88889V7.55556C20 8.08889 19.6444 8.44444 19.1111 8.44444C18.5778 8.44444 18.2222 8.08889 18.2222 7.55556V5.77778H12.8889V18.2222H14.6667C15.2 18.2222 15.5556 18.5778 15.5556 19.1111C15.5556 19.6444 15.2 20 14.6667 20H9.33333C8.8 20 8.44444 19.6444 8.44444 19.1111C8.44444 18.5778 8.8 18.2222 9.33333 18.2222H11.1111V5.77778H5.77778V7.55556C5.77778 8.08889 5.42222 8.44444 4.88889 8.44444C4.35556 8.44444 4 8.08889 4 7.55556V4.88889C4 4.35556 4.35556 4 4.88889 4H19.1111C19.6444 4 20 4.35556 20 4.88889Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59488 2.79415C2.92346 2.46558 3.45618 2.46558 3.78476 2.79415L20.9006 19.91C21.2292 20.2386 21.2292 20.7713 20.9006 21.0999C20.572 21.4285 20.0393 21.4285 19.7107 21.0999L2.59488 3.98403C2.26631 3.65545 2.26631 3.12273 2.59488 2.79415Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09494 2.84689C3.42352 2.51832 3.95624 2.51832 4.28482 2.84689L21.4007 19.9627C21.7292 20.2913 21.7292 20.824 21.4007 21.1526C21.0721 21.4812 20.5394 21.4812 20.2108 21.1526L3.09494 4.03676C2.76637 3.70819 2.76637 3.17546 3.09494 2.84689Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeywordNo);
export default __webpack_public_path__ + "static/media/ic_keyword_no.9dc03649119bea1d1df2a001cb6042e8.svg";
export { ForwardRef as ReactComponent };